import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BatchRequestsService } from './api/batchRequests.service';
import { ConstructionSetService } from './api/constructionSet.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ConstructionApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ConstructionApiModule> {
        return {
            ngModule: ConstructionApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ConstructionApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ConstructionApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
